import React, { Component } from 'react';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import {faSync, faCheckCircle} from '@fortawesome/fontawesome-free-solid';
import './update.scss';

export class Update extends Component {
    render() {
        const {process} = this.props;

        return (
            <div id="updateProcessCircle" className={process ? 'progress' : 'success'}>
                <div className={process ? 'inProgress' : 'hide'}>
                    <FontAwesomeIcon icon={faSync} spin/>
                </div>
                <div className={process ? 'hide': 'updated'}>
                    <FontAwesomeIcon icon={faCheckCircle}/>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/Form/Update.jsx